import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SeasonPlan } from '@coin/shared/core/util-models';
import { SeasonState } from '../../../season-mgmt/store';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import {
  V2DropdownComponent,
  V2ButtonComponent,
  V2DialogFrameComponent,
  V2DialogFooterComponent
} from '@coin/shared/core/ui-storybook';
import { TemplateWithValueDirective } from '@coin/shared/core/util-directives';

@Component({
  selector: 'admin-select-plan-dialog',
  templateUrl: './select-plan-dialog.component.html',
  styleUrls: ['./select-plan-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    V2DialogFrameComponent,
    V2DropdownComponent,
    FormsModule,
    TemplateWithValueDirective,
    V2DialogFooterComponent,
    V2ButtonComponent,
    TranslatePipe
  ]
})
export class SelectPlanDialogComponent {
  data = inject<{
    value: SeasonPlan;
  }>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<SelectPlanDialogComponent>>(MatDialogRef);
  private readonly seasonState = inject(SeasonState);

  plans = this.seasonState.plans;

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.dialogRef.close(this.data.value);
  }

  displayFn(plan: SeasonPlan): string {
    return plan.title;
  }

  compare(planOne: SeasonPlan, planTwo: SeasonPlan): boolean {
    return planOne?.id === planTwo?.id;
  }
}
